"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BeautyProductsOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M11 6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2v2a1 1 0 0 0-1 1v1c0 .029.002.058.004.086a2 2 0 0 0-1.417 1.83l-.543 13.042A1 1 0 0 0 7.043 26h5.915a1 1 0 0 0 1-1.042l-.544-13.041a2 2 0 0 0-1.417-1.831c.002-.028.004-.057.004-.086V9a1 1 0 0 0-1-1V6zm-2.414 6-.5 12h3.83l-.5-12h-2.83z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M18 9.535V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.535c1.196.692 2 1.984 2 3.465v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V13c0-1.48.805-2.773 2-3.465zM20 9V8h2v1h-2zm0 2a2 2 0 0 0-2 2v11h6V13a2 2 0 0 0-2-2h-2z" clip-rule="evenodd"></path></g>';
var BeautyProductsOutlineSVG = function BeautyProductsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BeautyProductsOutlineSVG = BeautyProductsOutlineSVG;
BeautyProductsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BeautyProductsOutlineSVG);
exports.default = _default;